import React from 'react';
import map from 'lodash/map';
import Visa_dark from '../../../Assets/images/Visa-dark.svg';
import BankAccount from '../../../Assets/images/BankAccountImage.svg';
import {isEmpty} from 'lodash';

function Sidebar(props) {

  if (!props.service_order_data || Object.keys(props.service_order_data).length === 0) return <div />;

  const { billing_address, frequency, property_type, pet_count, calculated_price } = props.service_order_data;
  const { stax_payment_object } = props?.service_order_data?.user_billing_info || {};
  const { coupon } = props.pricingCalc;

  const getTimePeriod = (months) => {
    if (months === 12) {
      return `1 year (10%)`
    } else {
      return '6 months (5%)'
    }
  }

  const getSavedAmount = (months, amount) => {
    if (months === 12) {
      return `Save $${getCurrency(amount)} (10%)`
    } else {
      return `Save $${getCurrency(amount)} (5%)`
    }
  }

  const getCurrency = (amount) => {
    return amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  }

  return (
    <React.Fragment>
      <div className={props.is_show_summary ? 'show_sidebar sidebar common_sidebar' : 'sidebar common_sidebar'}>
        <div className="title_details">
          <h3>Your Service Confirmed!</h3>
          <label className="subscription-details">Billing Details</label>
        </div>
        <div className="card_details_wrapper">
          <div className="card_details">
            <img src={JSON.parse(stax_payment_object).method === "card" ? Visa_dark : BankAccount}  alt="" style={stax_payment_object.method === "card" ? {} : {height: "20px" }} />
            <span className="card_details">**** {!isEmpty(stax_payment_object) && JSON.parse(stax_payment_object) && JSON.parse(stax_payment_object).card_last_four}
            </span>
          </div>
          {billing_address &&
            <p className="address">
              {`${billing_address.address},`}<br />
              {`${billing_address.city}, ${billing_address.state}, ${billing_address.zip_code}`}
            </p>
          }
        </div>
        <div className="hr"></div>

        <div className="weekly-service-from">
          <label className="subscription-details">Subscription details</label>
          <ul>
            <li>
              <label className="details">
                {`${frequency === 'bi_monthly' ? 'Every Other Week Service' : frequency === 'once' ? 'Just Once' : frequency === 'twice_weekly' ? 'Twice Weekly Service' : frequency} Service`}
              </label>
              <span className={calculated_price.service_base_price ? 'price' : 'price d-none'}>${calculated_price.service_base_price}</span>
            </li>
            <li>
              <label className="details">
                {`${calculated_price.cleaning_areas && calculated_price.cleaning_areas.items.length > 0 ? calculated_price.cleaning_areas.items[0].area : ''} `}
              </label>
            </li>
            <li>
              <label className="details">{`${property_type === 'townhouse' ? 'Town House' : property_type === 'single_family_small' ? 'Detached (Less than 0.5 acres. lot)'
                : property_type === 'single_family_large' ? 'Detached (More than 0.5 acres. lot)'
                  : ''}`}
              </label>
            </li>
            <li>
              <label className="details">
                {`${pet_count} Dogs`}
              </label></li>
          </ul>
        </div>
        <div className="hr"></div>
        <div className="weekly-service-from">
          <ul>
            {
              map(calculated_price.cleaning_areas && calculated_price.cleaning_areas.items, (item, i) => {
                if (item.price > 0) {
                  return (
                    <li key={i}>
                      <label className="details">{item.area}</label>
                      <span className="price">+${item.price}</span>
                    </li>
                  )
                }
              })
            }
          </ul>
          <ul>
            {
              map(calculated_price && calculated_price.recurring_add_ons && calculated_price.recurring_add_ons.recurring_addon_items, (item, i) => {
                if (item.type === 'add_on') {
                  return (
                    <li key={i}>
                      <label className="details">{item.name}</label>
                      <span className="price">+${item.price}</span>
                    </li>
                  )
                }

              })
            }
          </ul>
        </div>
        <div className='price-per-weekly common_price-per-weekly'>
          <div className="heading_wrapper">
            <div className="heading">
              {calculated_price.is_prepaid
                ? <h4>Total for {getTimePeriod(calculated_price.prepay_months)}</h4>
                : <h4>Price {calculated_price &&
                  calculated_price.frequency === 'bi_monthly' ?
                  'per Every Other Week' : calculated_price.frequency === 'once' ?
                    'for a single' : calculated_price.frequency === 'twice_weekly' ?
                      'per Twice Weekly' : calculated_price.frequency} visit</h4>}
            </div>
            <div className="price">
              {calculated_price.is_prepaid
                ? `$${getCurrency(calculated_price.prepay_price[calculated_price.price_shown].price_after_discount)}`
                : `$${calculated_price.total_price_per_service}`}
            </div>
          </div>
          <span>
            {calculated_price.is_prepaid ? getSavedAmount(calculated_price.prepay_months, calculated_price.prepay_savings) :
              `Billed ${frequency === 'once' ? 'Just Once' : 'Monthly'}`}
          </span>
        </div>
        <div>
          <div className="one-time-charges">
            <div className="label_wrapper">
              <h4>One-time charges</h4>
              <div>
                {map(calculated_price.one_time_charges && calculated_price.one_time_charges.one_time_items, (item, i) => {
                  if (item.type === 'last_clean') {
                    return (<p className="since-las" key={i}> {
                      item.name === 'less_than_2_weeks' ? 'Less than 2 weeks' : item.name === '2-3_weeks' ? '2-3 weeks' :
                        item.name === '1-2_months' ? '2 to 6 weeks' : item.name === '2_months_or_more' ? 'More than 6 weeks' : item.name === '3_months_or_more' ? 'More than 3 months' : item.name
                    } since last clean </p>)
                  }
                  return <p className="since-las" key={i}>{item.name}</p>
                })}
              </div>
            </div>
            <label className="price">${calculated_price.one_time_charges && calculated_price.one_time_charges.total_one_time_charge}</label>
          </div>
          <div className="total_wrapper">
            <div className="total_price">
              <label className="title">Total for first visit</label>
              <span className="price">${calculated_price.total_price_for_first_visit?calculated_price.total_price_for_first_visit.toFixed(2):0}</span>
            </div>
            {coupon && coupon.coupon_applied &&
              <div className="applied_coupon_code">
                <div className="current_code"><label>{coupon.coupon_applied}</label><span>Applied</span></div>
                <div className="discount_price">{coupon.savings ? `-$${coupon.savings}` : '$0'}</div>
              </div>}
            {calculated_price.is_prepaid &&
              <div className="prepay_price">
                Your total to pay today is <b>${getCurrency(calculated_price.prepay_price[calculated_price.price_shown].price_after_discount)}</b>
              </div>}
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Sidebar